import React, { useEffect } from "react";
import { PropTypes } from "prop-types";

import ConditionalRenderForm from "./ConditionalRenderForm";

import "css/admin/conditional_render.scss";

function ConditionalRender({ conditions, onChange }) {
  useEffect(() => {
    const last_condition = conditions[conditions.length - 1];

    if (
      !last_condition ||
      (last_condition.type &&
        last_condition.operator &&
        last_condition.predicat)
    )
      onChange(addConditionalRender());
  }, []);

  const addConditionalRender = () => {
    const newConditions = [
      ...conditions,
      { type: "user", operator: "", predicat: "" },
    ];

    return newConditions;
  };

  const onChangeOption = (opt, value, rank) => {
    let newConditions = conditions;
    const newCondition = conditions[rank];

    if (rank === conditions.length - 1) {
      newConditions = addConditionalRender();
    }

    newConditions[rank] = {
      ...newCondition,
      [opt]: value,
    };

    onChange(newConditions);
  };

  const removeConditionalRender = (rank) => {
    if (conditions.length > 1) {
      conditions.splice(rank, 1);
      onChange(conditions);
    } else {
      onChange([{ type: "user", operator: "", predicat: "" }]);
    }
  };

  return (
    <div className="conditional-render-container">
      {conditions.map((condition, i) => (
        <div
          key={`conditional-render-form-line-${i}`}
          className="conditional-render-form-line"
        >
          <ConditionalRenderForm
            key={`conditional-render-form-${i}`}
            conditions={conditions}
            onChange={onChangeOption}
            operator={condition.operator}
            predicat={condition.predicat}
            type={condition.type}
            rank={i}
          />
          {((condition.type && condition.operator) || condition.predicat) && (
            <div className="btn-remove-conditional">
              <i
                className="material-icons editor-multi-icons"
                onClick={() => removeConditionalRender(i)}
              >
                delete
              </i>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

ConditionalRender.propTypes = {
  onChange: PropTypes.func.isRequired,
  conditions: PropTypes.array.isRequired,
};

ConditionalRender.defaultProps = {
  conditions: [{ type: "user", operator: "", predicat: "" }],
};

export default ConditionalRender;
